// removed by extract-text-webpack-plugin
module.exports = {"login-page":"_1yiKFrJuOIs6p23xGdSjTq_0","logo":"_2aheEpw3u4Mf1c8r0-ABvi_0","watch":"_2GDEyqiKrm5kHMl8tzxVDW_0","raw":"_2bSNu7EUiSTAOtiyDQMZEJ_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ffb130e2","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/routes/HomeView/login-page.vue
// module id = 240
// module chunks = 0